import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import axios from "axios";
import App from "./components/App";
import {store} from "./store/store";
import VeeValidate from "vee-validate";
import Cookies from "js-cookie";
import VueAuthenticate from 'vue-authenticate';
import VueTour from 'vue-tour'

Vue.use(VueTour)

Vue.use(VueAuthenticate, {
  baseUrl: process.env.MIX_APP_URL, // Your API domain


  providers: {
    linkedin: {
      clientId: process.env.MIX_LINKEDIN_CLIENT_ID,
      redirectUri: process.env.MIX_LINKEDIN_REDIRECT_URI,
      name: 'linkedin',
      url: '/auth/linkedin',
      authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
      scope: ['r_emailaddress', 'r_liteprofile'],
      requiredUrlParams: ['state', 'scope'],
      scopeDelimiter: ' ',
      state: 'STATE',
      oauthType: '2.0',
      popupOptions: { width: 527, height: 582 }
    },
    facebook: {
      clientId: process.env.MIX_FACEBOOK_CLIENT_ID,
      redirectUri: process.env.MIX_FACEBOOK_REDIRECT_URI,
    },
    google: {
      clientId: process.env.MIX_GOOGLE_KEY,
      redirectUri: process.env.MIX_GOOGLE_REDIRECT_URI,
    },
    vk: {
      name: 'vk',
      url: '/auth/vkontakte',
      authorizationEndpoint: 'https://oauth.vk.com/authorize',
      requiredUrlParams: ['v'],
      optionalUrlParams: ['scope'],
      scope: ['user:email'],
      scopeDelimiter: ' ',
      oauthType: '2.0',
      popupOptions: {width: 1020, height: 618},
      clientId: process.env.MIX_VKONTAKTE_KEY,
      redirectUri: process.env.MIX_VKONTAKTE_REDIRECT_URI,
      v: 5.103
    },
  }
});

const VueScrollTo = require("vue-scrollto");

// register globally
import YmapPlugin from 'vue-yandex-maps';

const options = { // you may define your apiKey, lang and version or skip this.
  lang: 'hy_AM', // 'ru_RU' by default
  version: '2.1' // '2.1' by default
};
Vue.use(YmapPlugin, options);
// window.$ = window.jQuery = require("jquery");
Vue.use(VueRouter);
Vue.use(VeeValidate);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
// Vue.component('pagination', require('laravel-vue-pagination'));

Vue.prototype.$http = axios;
Vue.prototype.$Cookies = Cookies;

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDvvqgc0KhI8v-1cqDl2lbDpy12TFVKe_U',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },
});

import vuescroll from 'vuescroll';

// You can set global config here.
Vue.use(vuescroll, {
  name: 'vue-scroll'
});


const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.path !== from.path) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  if (to.path !== from.path) {
    NProgress.done();
  }
});


// store.dispatch('getData').then(res => {

// })

const app = new Vue({
  el: "#app",
  components: {App},
  render: h => h(App),
  router,
  store
});



// WEBPACK FOOTER //
// ./resources/js/app.js